/**
 * @file 在生命周期过程中获取远程数据的能力
 * @author zhanglili
 */

import {compose, mapProps} from 'recompose';
import {identity, zipObject} from 'lodash';
import requireFetch from '../requireFetch';
import onDidUpdate from '../onDidUpdate';
import withLoading from '../withLoading';

const configureRequireFetch = (fetches, options) => {
    const configurations = Object.values(fetches);
    const keys = Object.keys(fetches);
    const combinedFetch = async props => {
        const tasks = configurations.map(([selector, task]) => task(selector(props), props));
        const values = await Promise.all(tasks);
        const result = zipObject(keys, values);
        return result;
    };

    return requireFetch(combinedFetch, {...options, pendingKey: 'mountPending'});
};

const configureOnDidUpdate = (fetches, options) => {
    const modifiedOptions = {
        ...options,
        pendingKey: 'updatePending',
        awaitAsync: true
    };

    return onDidUpdate(fetches, modifiedOptions);
};

const configureMapProps = ({pendingKey = 'pending'} = {}) => {
    const mapper = ({mountPending, updatePending, ...props}) => {
        const pending = mountPending || updatePending;

        return {
            ...props,
            [pendingKey]: pending
        };
    };

    return mapProps(mapper);
};

const configureWithLoading = ({loadingComponent, pendingKey = 'pending'} = {}) => {
    if (loadingComponent) {
        return withLoading(loadingComponent, {pendingKey});
    }

    return identity;
};

export default (fetches, options) => compose(
    configureRequireFetch(fetches, options),
    configureOnDidUpdate(fetches, options),
    configureMapProps(options),
    configureWithLoading(options)
);
